export const SET_ERROR = 'SET_ERROR';
export const UNSET_ERROR = 'UNSET_ERROR';
export const SET_LOADING = 'SET_LOADING';
export const SET_AB_TESTING = 'SET_AB_TESTING';
export const UNSET_AB_TESTING = 'UNSET_AB_TESTING';
